// anbieter-karten — der Marktueberblick im Teilverkauf-Ratgeber.
//
// Sieben Anbieter mit je vier bis fuenf Konditionen und einem Status. Der
// Status ist der Grund, warum das ein eigener Baustein ist und keine allgemeine
// Karte: welche Anbieter aktiv am Markt sind, aendert sich, und dann muss man
// eine Zeile umschreiben statt eine Karte umzubauen.
//
// Rechtlich heikel ist hier nur eines: Konditionen veralten. Deshalb hat der
// Baustein ein eigenes Feld fuer den Stand, und es steht sichtbar ueber den
// Karten — nicht kleingedruckt am Seitenende.
//
// Einstellungen am Wrapper:
//   data-titel     Ueberschrift
//   data-stand     z. B. "Konditionen Stand Juli 2026"
//   data-spalten   1–3, Standard 2
import { el, leerHinweis, lesZahl } from '@lib/bausteine/dom';
import { zerlegeZeilen } from '@lib/bausteine/zerlege';
import { zeichneAus } from '@lib/bausteine/auszeichnung';

/** "aktiv", "Aktiv", "ja" — alles dasselbe. Alles andere gilt als inaktiv. */
function istAktiv(status: string | undefined): boolean {
  const wort = (status ?? '').trim().toLowerCase();
  return wort === 'aktiv' || wort === 'ja' || wort === 'active';
}

export function anbieterKarten(wurzel: HTMLElement, quelle: string): Node {
  const karten = zerlegeZeilen(quelle);

  if (karten.length === 0) {
    return leerHinweis('Noch keine Anbieter. Format: Name | aktiv | Kondition; Kondition; Kondition');
  }

  const titel = (wurzel.getAttribute('data-titel') ?? '').trim();
  const stand = (wurzel.getAttribute('data-stand') ?? '').trim();
  const spalten = lesZahl(wurzel, 'data-spalten', 2, 1, 3);

  return el(
    'section',
    { class: 'eoe-reset eoe-anbieter' },
    titel && el('h3', { class: 'eoe-titel' }, titel),
    stand && el('p', { class: 'eoe-anbieter__stand' }, stand),
    el(
      'ul',
      { class: 'eoe-anbieter__raster', style: `--eoe-spalten: ${spalten}` },
      ...karten.map((karte) => {
        const [name, status, konditionen] = karte.felder;
        const aktiv = istAktiv(status);

        // Konditionen werden mit Semikolon getrennt, weil der Senkrechtstrich
        // hier schon die Felder trennt.
        const punkte = (konditionen ?? '')
          .split(';')
          .map((punkt) => punkt.trim())
          .filter(Boolean);

        return el(
          'li',
          { class: `eoe-anbieter__karte${aktiv ? '' : ' eoe-anbieter__karte--inaktiv'}` },
          el(
            'div',
            { class: 'eoe-anbieter__kopf' },
            el('h4', { class: 'eoe-anbieter__name' }, name ?? ''),
            el(
              'span',
              { class: `eoe-anbieter__badge${aktiv ? '' : ' eoe-anbieter__badge--inaktiv'}` },
              aktiv ? 'Aktiv' : status || 'Nicht aktiv',
            ),
          ),
          punkte.length > 0 &&
            el(
              'ul',
              { class: 'eoe-anbieter__punkte' },
              ...punkte.map((punkt) => el('li', null, zeichneAus(punkt))),
            ),
        );
      }),
    ),
  );
}
